export default __webpack_public_path__ + "static/media/delete_red.1639006f.svg";